module.exports = __webpack_public_path__ + "static/media/KidsAbility.1a185eb8.png";